var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_c('b',[_vm._v("Language :")]),_vm._v(" "+_vm._s(_vm.locale))]),_c('p',{staticStyle:{"white-space":"pre-wrap"}},[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }